import { render, staticRenderFns } from "./Vision-general-de-compras.vue?vue&type=template&id=f39bc162"
import script from "./Vision-general-de-compras.vue?vue&type=script&lang=js"
export * from "./Vision-general-de-compras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports